
import {Vue,Component} from 'vue-property-decorator'
import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import RadioButton from '@/components/radio-button.vue';
	import {imgHost} from '@/utils/config'
import {
  productWishList,
  producthotWishInfo
} from '@/api/supplier';
import{
  getSearchDate,
  nextDay
}from "@/utils/index"
@Component({
		name: 'product-list',
		components: {
			PageFooter,
      PickerDate,
      RadioButton
		}
	})
export default class ProductRank extends Vue{
  private imgurl = imgHost
  private pageNo = 1;
  private pageSize = 10;
  private total = null;
  private list:any = [];
  private filterTime = getSearchDate(2).join('/');
  private radioList = [
    {value:3,label:'近3天'},
    {value:7,label:'近7天'},
    {value:15,label:'近15天'},
    {value:30,label:'近30天'},
  ]
  private radioType = null
  private Keywords = ''
  private hotlist:any = []
  private tableloading = false

  private mounted () {
    this.getlist()
  }

  private changeradio(val){
    // console.log(val)
    // console.log(getSearchDate(2,false,-(val-1))[0],getSearchDate(2,false)[0])
    // let date = new Date()
    // let olddate = new Date(new Date().getTime()-1000*60*60*24*(this.radioType-1))
    // let year = date.getFullYear()
    // let month = date.getMonth()+1>=10?date.getMonth()+1:'0'+(date.getMonth()+1)
    // let day = date.getDate()>=10?date.getDate():'0'+date.getDate()

    // let oldyear = olddate.getFullYear()
    // let oldmonth = olddate.getMonth()+1>=10?olddate.getMonth()+1:'0'+(olddate.getMonth()+1)
    // let oldday = olddate.getDate()>=10?olddate.getDate():'0'+olddate.getDate()

    // this.filterTime = [[oldyear,oldmonth,oldday].join('-'),[year,month,day].join('-')].join('/')
    this.filterTime = [getSearchDate(2,false,-(val-1))[0],getSearchDate(2,false)[0]].join('/')
    this.getlist()
  }

  private exportlist(){
    let url = location.origin + '/pc/product/productWishListExport?Keywords=' + this.Keywords
    if (this.filterTime) {
      var dt = this.filterTime.split('/');
      url += '&StartTime=' + dt[0];
      url += '&EndTime=' + nextDay(dt[1],1)
    }
    window.open(url)
  }

  private clearSearch(){
    this.Keywords = ''
    this.radioType = null
    this.filterTime = getSearchDate(2).join('/')
    this.pageNo = 1;
    this.getlist()
  }

  private async getlist(){
    try{
      this.tableloading = true
      let data:any = {
        Skip:(this.pageNo-1)*this.pageSize,
        Take:this.pageSize,
        Keywords:this.Keywords
      }
      if (this.filterTime) {
				let dt = this.filterTime.split('/');
        // console.log((new Date(dt[1]).getTime() - new Date(dt[0]).getTime())/1000/60/60/24)
        if((new Date(dt[1]).getTime() - new Date(dt[0]).getTime())/1000/60/60/24 > 30){
          this.$message.error('许愿时间最多选择30天以内')
          return
        }
				data.StartTime = dt[0];
				data.EndTime = nextDay(dt[1],1)
			}
      let list = await producthotWishInfo(data)
      if(list.IsSuccess){
        this.hotlist = list.Result
      }
      let res:any = await productWishList(data)
      if(res.IsSuccess){
        // console.log(res)
        this.list = res.Result.Results
        this.total = res.Result.Total
      }
    }finally{
      this.tableloading = false
    }
  }

  private changeCurrent(e:number){
    this.pageNo = e
    this.getlist()
  }
}
